module.exports = __webpack_public_path__ + "07_bob_grey.1a034ee2.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer5/07_bob_grey.png
// module id = 3xnX
// module chunks = 0